export function getStatusColor(status) {
  const classes = new Map([
    ['Distribuído', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Distribuir', 'bg-[#FFF1E4] text-[#EE750E]'],
    ['Não enviado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['Aprovado', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['Recusado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['estornado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['pago', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['enviado', 'bg-[#DEFFE0] text-[#008E0A]'],
    ['rejeitado', 'bg-[#FFE9E7] text-[#FF1F00]'],
    ['aprovado', 'bg-[#DEFFE0] text-[#008E0A]'],
  ])
  return classes.get(status) || 'bg-blue-200 text-black'
}

export function convertToJsonArray(data) {
  const jsonArray = []
  for (const key in data) {
    jsonArray.push({ id: key, name: data[key] })
  }
  return jsonArray
}

export const addClassesLinked = (classes) => {
  const classesLinkeds = []
  classes.forEach((classObj) => {
    if (classObj.linkeds && Array.isArray(classObj.linkeds)) {
      classesLinkeds.push(...classObj.linkeds)
    }
  })

  const allClasses = [...classes, ...classesLinkeds]
  const { classesNoRepeat } = dontRepeatClass(allClasses)

  return { classesNoRepeat, classesLinkeds }
}

export const dontRepeatClass = (classes) => {
  const classesNoRepeat = []

  classes.forEach((classe, idx, arg) => {
    const count = countRepeat(arg, classe)
    if (count === 1) {
      classesNoRepeat.push(classe)
    }
    const countNR = countRepeat(classesNoRepeat, classe)
    if (countNR === 0) {
      classesNoRepeat.push(classe)
    }
  })

  return { classesNoRepeat }
}

const countRepeat = (array, searchObject) => {
  let count = 0
  array.forEach((element) => {
    if (element.id === searchObject.id) {
      count++
    }
  })
  return count
}
